//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sealpwItem from './component/sealpw-item'
export default {
    components: {sealpwItem},
    props: [],
    data () {
        return {
            activeNames: '',
        }
    },
    watch: {
        
    },
    methods: {
        cancleHandler: function() {
            this.activeNames = ""
        }
    },
    mounted: function() {

    }
}
